var _path, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNorneBrukerIkon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  "data-name": "Layer 1",
  viewBox: "0 0 200 200"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#2a2a2a",
  d: "M199.67 194h-3a96.67 96.67 0 0 0-193.34 0h-3a99.67 99.67 0 0 1 199.34 0"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 100,
  cy: 46.25,
  r: 40.25,
  fill: "#2a2a2a"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#2a2a2a",
  d: "M100 87a40.75 40.75 0 1 1 40.75-40.75A40.8 40.8 0 0 1 100 87m0-80.49a39.75 39.75 0 1 0 39.75 39.74A39.79 39.79 0 0 0 100 6.51"
})));
export default SvgNorneBrukerIkon;